import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ButtonLink from '../../components/elements/ButtonLink';
import Card from '../../components/elements/Card';
import DataTable from '../../components/elements/DataTable';
import ErrorHandler from '../../components/elements/ErrorHandler';
import Text from '../../components/fields/Text';
import AturHargaSubUserFilter from '../../components/fragments/AturHargaSubUserFilter';
import IconManagementMerchant from '../../components/icons/IconManagementMerchant';
import { AppContext } from '../../contexts';
import { thousand } from '../../utils/format';
import { useDebounce } from '../../utils/hooks';
import { getRegional } from '../../utils/storage';
import { fetchSubUserProductPriceLists } from './actions';
import styles from './styles.scoped.css';

export default function SubUser({ category }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { setBreadcrumbs } = useContext(AppContext);
  const [search, setSearch] = useState('');

  const userRegion = getRegional();
  const { dataDetailUser } = useSelector((state) => state.pageBase);
  const {
    page = 1,
    size = 10,
    regional = dataDetailUser.regionalId === 'All'
      ? ''
      : dataDetailUser.regionalId,
    provinceId = dataDetailUser.provinceId === 'All'
      ? ''
      : dataDetailUser.provinceId,
    cityId = '',
    districtId = '',
    villageId = '',
  } = queryString.parse(location.search.replace('?', ''));

  const {
    dataSubUserProductPriceLists: { data, meta },
    isLoadingSubUserProductPriceLists,
    messageSubUserProductPriceLists,
  } = useSelector((s) => s.prices);

  const debounceParams = useDebounce(
    page +
      size +
      category +
      regional +
      provinceId +
      cityId +
      districtId +
      villageId +
      search,
    500
  );

  function getAllParams(page) {
    let allParams = {
      regional,
      page: page,
      provinceId,
      cityId,
      districtId,
      villageId,
      search,
      // categoryId: category.categoryId
    };
    if (!userRegion) {
      allParams.regional = regional;
    }
    return allParams;
  }

  const allParams = {
    page,
    size,
    search,
    regional: regional === 'All' ? '' : regional,
    provinceId: provinceId === 'All' ? '' : provinceId,
    cityId: cityId === 'All' ? '' : cityId,
    districtId: districtId === 'All' ? '' : districtId,
    villageId: villageId === 'All' ? '' : villageId,
  };

  useEffect(() => {
    setBreadcrumbs(['Atur HET LPG 3 Kg']);
  }, []);

  useEffect(() => {
    if (category?.categoryId) {
      dispatch(
        fetchSubUserProductPriceLists({
          ...allParams,
          // categoryId: category.categoryId,
        })
      );
    }
  }, [category, debounceParams]);

  const fetchProductList = (page) => {
    dispatch(fetchSubUserProductPriceLists(getAllParams(page + 1)));
  };

  const renderAction = (
    region,
    provinceId,
    cityId,
    districtId,
    villageId,
    minPrice,
    maxPrice
  ) => {
    const query = queryString.stringify({
      region,
      provinceId,
      cityId,
      districtId,
      villageId,
      minPrice,
      maxPrice,
    });
    return (
      <ButtonLink
        className={styles['btn-detail']}
        outlined
        to={location.pathname + '/set/subpangkalan?' + query}
      >
        <span>Ubah Harga</span>
      </ButtonLink>
    );
  };

  const column = [
    { heading: 'Regional', value: 'regional' },
    { heading: 'Provinsi', value: 'provinceName' },
    { heading: 'Kota/Kab', value: 'cityName' },
    { heading: 'Kecamatan', value: 'districtName' },
    { heading: 'Kelurahan', value: 'villageName' },
    {
      heading: 'Range HET LPG 3 Kg',
      value: ({ minPrice, maxPrice }) =>
        `Rp${thousand(minPrice)} - Rp${thousand(maxPrice)}`,
    },
    {
      heading: 'Ubah Harga',
      value: ({
        regional,
        provinceId,
        cityId,
        districtId,
        villageId,
        minPrice,
        maxPrice,
      }) =>
        renderAction(
          regional,
          provinceId,
          cityId,
          districtId,
          villageId,
          minPrice,
          maxPrice
        ),
    },
  ];

  if (messageSubUserProductPriceLists) {
    return <ErrorHandler message={messageSubUserProductPriceLists} />;
  }

  return (
    <>
      <AturHargaSubUserFilter />
      <Card className={styles.searchContainer}>
        <div className={styles.uploadContainer}>
          <ButtonLink
            className={styles.updatePriceBtn}
            to={'/price/set/subpangkalan?scope=byRegional'}
            type="primary"
          >
            <IconManagementMerchant /> Ubah Per Wilayah
          </ButtonLink>
          <ButtonLink
            className={styles.updatePriceBtn}
            style={'red'}
            to={'/price/setting-sekaligus/subpangkalan'}
            type={'primary'}
          >
            <img src="assets/ic-upload.svg" />
            Ubah Harga Dengan File
          </ButtonLink>
        </div>
        <div className={styles['filter-wrap']}>
          <div className={styles.filters}>
            <Text
              className={styles['search-bar']}
              hideLabel
              inputProps={{
                placeholder: 'Cari data...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => setSearch(e.target.value),
              }}
            />
          </div>
        </div>
      </Card>
      <Card className={styles.table}>
        <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={200}
            loading={isLoadingSubUserProductPriceLists}
            meta={meta}
            onEndReached={() => fetchProductList(meta.page)}
            onRefresh={fetchProductList}
            size={size}
            withIndex
          />
        </div>
      </Card>
    </>
  );
}

SubUser.propTypes = {
  category: PropTypes.shape({
    categoryId: PropTypes.string,
    unit_name: PropTypes.string,
    unit_symbol: PropTypes.string,
  }),
};
